import { withChartLayout } from 'components/common';
import SavedSpecialCharts from 'components/features/chart/special-charts/saved-special-charts/SavedSpecialCharts';

const SavedSpecialChartsPage = withChartLayout('Saved Special Charts')(SavedSpecialCharts);
export default SavedSpecialChartsPage;
